import capitalize from "lodash/fp/capitalize";

class Controller {
  constructor(Sections, Events, $stateParams, PaymentMethod, Country) {
    "ngInject";

    this.sections = Sections.settingsSections;
    this.Events = Events;
    this.paymentMethodId = $stateParams.id;
    this.PaymentMethod = PaymentMethod;
    this.Country = Country;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.isDisabled = {
      name: true,
      references: true,
      countries: true,
    };

    this.onAutoCompleteSearch = this.onAutoCompleteSearch.bind(this);
    this.updateName = this.updateName.bind(this);
    this.updateReferences = this.updateReferences.bind(this);
    this.updateCountries = this.updateCountries.bind(this);
  }

  $onInit() {
    this.PaymentMethod.get(this.paymentMethodId).$promise.then(
      (response) => {
        this.paymentMethod = response;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  addReference() {
    this.paymentMethod.references.push({
      name: null,
      type: null,
      min_length: null,
      max_length: null,
      required: false,
    });
  }

  onAutoCompleteSearch(query) {
    return this.Country.search(query).$promise.then((response) =>
      response.hits.map(({ _id, _source: { name } }) => ({
        _id,
        name,
      }))
    );
  }

  updateName() {
    const item = { name: this.paymentMethod.name };
    this.updateMethod({ action: "name", item });
  }

  updateReferences() {
    const item = { references: this.paymentMethod.references };
    this.updateMethod({ action: "references", item });
  }

  updateCountries() {
    const countries = this.paymentMethod.countries.map(({ _id }) => _id);
    const item = { countries };

    this.updateMethod({ action: "countries", item });
  }

  updateMethod({ action, item }) {
    this.PaymentMethod.update(this.paymentMethodId, item).$promise.then(
      (response) => {
        this.paymentMethod = response;

        this.Events.emit(this.successNotificationEvent, {
          message: `Payment Method ${capitalize(
            action
          )} is update successfully`,
        });

        this.isDisabled[action] = true;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/paymentMethod/paymentMethod.controller.js